import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Project} from '../model/project';
import {Questionnaire} from '../model/questionnaire';
import {Terminal} from '../model/terminal';

@Component({
selector:'breadcrumb',
  template: `

    <div class="bc-icons-2">

      <ol class="breadcrumbs col-md-12 vista">
        <li><a><span class="serverIcon"><i class="text-white fas fa-server"></i></span></a></li>
        <li class="breadcrumb-item" *ngFor="let str of path"><a class="text-white" (click)="onLinkClick(str)">{{str.name}}</a><i *ngIf="isLastElement(str)" class="text-white fa fa-caret-right mx-2" aria-hidden="true"></i></li>
      </ol>
    </div>
  `,
  styles:[`
    .serverIcon{margin-right: 8px;}
    .vista{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding: 0.75rem 1rem;
        margin-bottom: 1rem;
        list-style: none;
    }
    .hm-gradient {
      background-image: linear-gradient(to top, #f3e7e9 0%, #e3eeff 99%, #e3eeff 100%);
    }
    .darken-grey-text {
      color: #2E2E2E;
    }
    .breadcrumb-item{
      margin-left: 3px;
      border-style: solid;
      border-width: thin;
      border-color: transparent;
    }
    .bc-icons .breadcrumb-item + .breadcrumb-item::before {
      content: none; }
    .bc-icons .breadcrumb-item.active {
      color: #eeeeee; }

    .bc-icons-2 .breadcrumb-item + .breadcrumb-item::before {
      content: none; }
    .bc-icons-2 .breadcrumb-item.active {
      color: #455a64; }


    .light-font .breadcrumb-item + .breadcrumb-item::before {
      color: #fff; }
    .light-font .breadcrumb-item.active {
      color: #cfd8dc; }

    .dark-font .breadcrumb-item + .breadcrumb-item::before {
      color: #fff; }
    .dark-font .breadcrumb-item.active {
      color: #455a64; }

  .breadcrumbs{background-image: url('../../assets/images/bkg2.png');}

  .breadcrumb-item:hover {
    border-style: solid;
    border-width: thin;
    border-color: teal;
    border-radius: 3px;
    background-image: linear-gradient(white, transparent);
  }

  .breadcrumb-item:hover:after {
    border-style: solid;
    border-width: thin;
    border-color: teal;
    border-radius: 3px;
    background-image: linear-gradient(white, transparent);
  }
  `]
})

export class BreadCrumbComponent {

  @Input() path:Array<Project|Questionnaire|Terminal>;
  @Output() breadCrumbLink:EventEmitter<Project|Questionnaire|Terminal>;
  constructor() {
    this.breadCrumbLink = new EventEmitter();
  }


  onLinkClick(str: (Project|Questionnaire|Terminal)) {

    this.breadCrumbLink.emit(str);
  }

  private isLastElement(str:Project|Questionnaire|Terminal):boolean {
    // tslint:disable-next-line:triple-equals
    if(this.path.indexOf(str)!=this.path.length-1) {
      return true;
    }
    return false;
  }
}
